import * as sentry from './sentry'

declare global {
    interface Navigator {
        webkitTemporaryStorage: {
            queryUsageAndQuota: (
                success: (usedBytes: number, grantedBytes: number) => void,
                failure: (error: Error) => void
            ) => void
        }
    }
}

export type TQuotaData = {
    usedBytes: number
    grantedBytes: number
}

export async function queryUsageAndQuota(): Promise<TQuotaData> {
    return new Promise<TQuotaData>((resolve, reject) => {
        if (navigator.webkitTemporaryStorage) {
            navigator.webkitTemporaryStorage.queryUsageAndQuota(
                function (usedBytes, grantedBytes) {
                    resolve({ usedBytes, grantedBytes })
                },
                function (error) {
                    sentry.err(error, { tags: { context: 'queryUsageAndQuota failed' } })
                    reject(error)
                }
            )
        } else {
            reject(new Error('Storage API unavailable'))
        }
    })
}
